import { render, staticRenderFns } from "./UpgradeNeeded.vue?vue&type=template&id=00e31bf4"
import script from "./UpgradeNeeded.vue?vue&type=script&lang=js"
export * from "./UpgradeNeeded.vue?vue&type=script&lang=js"
import style0 from "./UpgradeNeeded.vue?vue&type=style&index=0&id=00e31bf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports